import { Pipe, PipeTransform, inject } from '@angular/core';
import moment from 'moment';

import { FormatService } from 'src/app/_core/format.service';

/**
 * Impure pipe (rendered every digest cycle)
 * so moment.fromNow() can update its return value
 */
@Pipe({
  name: 'agrFromNow',
  // eslint-disable-next-line @angular-eslint/no-pipe-impure
  pure: false,
  standalone: false
})
export class FromNowPipe implements PipeTransform {
  private formatService = inject(FormatService);

  transform(value: number | string | Date): string {
    return moment(value).locale(this.formatService.dateLocale).fromNow();
  }
}
